import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PdfIcon from "../../../../../shared/assets/icons/PdfIcon.png";
import styles from "../../JobBatch.module.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import moment from "moment";
import Decrypt from "../../../../../shared/utils/Decrypt";
import StoreSearch from "../../../Campaign/StoreSearch";

const Completed = ({ onClusterChange, isPaintingService }) => {
  const [expandedCluster, setExpandedCluster] = React.useState(null);
  const [expandedBatch, setExpandedBatch] = React.useState(null);
  const { id } = useParams();
  const [clusters, setClusters] = React.useState([]);
  const [clusterLoading, setClusterLoading] = useState(false);
  const batchRefs = useRef({});
  const containerRef = useRef(null);

  const handleAccordionToggle = (clusterTitle, batchTitle) => (event) => {
    event.stopPropagation();
    if (clusterTitle) {
      setExpandedCluster((prev) =>
        prev === clusterTitle ? null : clusterTitle,
      );
    }
    if (batchTitle) {
      setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
    }
  };

  React.useEffect(() => {
    if (id) {
      // new function to call api of completed clusters
      // fetchAllJobsBasedOnCampaignId(id);
      fetchAllCompletesCluster(id);
    }
  }, [id]);

  // Helper function to calculate total jobs in a cluster
  const calculateTotalJobsInCluster = (cluster) => {
    return cluster?.batches?.reduce(
      (total, batch) => total + (batch.jobs?.length || 0),
      0,
    );
  };

  // fetch Jobs
  // const fetchAllJobsBasedOnCampaignId = async (id) => {
  //   setClusterLoading(true);
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_URL}/jobs/getAllJobs?campaignId=${id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       }
  //     );
  //     if (response?.data?.success) {
  //       // setAvailableJobs(response.data.data);
  //       fetchAllBatchesBasedOnCampaignId(response.data.data, id);
  //     }
  //   } catch (error) {
  //     setClusterLoading(false);

  //     console.error("error in while fetching jobs", error);
  //   }
  // };
  // Check if service is painting

  const getStatusLabel = (status) => {
    switch (status) {
      case "Requested":
        return "PDI Status:Requested";
      case "Approved":
        return "PDI Status:Approved";
      case "Rejected":
        return "PDI Status:Rejected";
      default:
        return "Unknown Status";
    }
  };

  // fetch batches
  // const fetchAllBatchesBasedOnCampaignId = async (jobs, id) => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_URL}/batchOfJobs/getAllBatchesForVendor?campaignId=${id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       }
  //     );
  //     if (response?.data?.success) {
  //       const updatedBatches = await response?.data?.data.map((batch) => ({
  //         ...batch,
  //         jobs: [],
  //       }));

  //       // First, check if campaign has Recce phase by looking at jobs
  //       const hasReccePhase = jobs.some((job) => job.jobApprovalStatus);

  //       // Include jobs based on campaign type
  //       jobs?.forEach((job) => {
  //         const batch = updatedBatches?.find(
  //           (batch) => batch._id === job.batchOfJobsForVendorId
  //         );

  //         if (batch) {
  //           if (hasReccePhase) {
  //             // For Recce phase - only include approved jobs
  //             if (job?.jobApprovalStatus?.clientStatus === 1) {
  //               batch.jobs.push(job);
  //             }
  //           } else {
  //             // For Manufacturing phase - include all jobs
  //             batch.jobs.push(job);
  //           }
  //         }
  //       });
  //       // setAvailableBatches(updatedBatches);
  //       fetchAllClustersBasedOnCampaignId(updatedBatches, id);
  //     }
  //   } catch (error) {
  //     setClusterLoading(false);

  //     console.error("error in while fetching jobs", error);
  //   }
  // };

  // fetch clusters
  // const fetchAllClustersBasedOnCampaignId = async (updatedBatches, id) => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_URL}/vendorClusterBatches/getAllClusterBatches?campaignId=${id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         },
  //       }
  //     );
  //     if (response?.data?.success) {
  //       // Filter for completed clusters (status === 2)
  //       const updatedClusters = await response?.data?.data // cluster status must be 2
  //         .filter((cluster) => cluster?.status === 2)
  //         .map((cluster) => ({
  //           ...cluster,
  //           batches: [],
  //         }));
  //       updatedBatches?.forEach((batch) => {
  //         const cluster = updatedClusters.find(
  //           (cluster) => cluster?._id === batch.idOfClusterOfBatchesForVendor
  //         );
  //         if (cluster) {
  //           cluster?.batches?.push(batch);
  //         }
  //       });

  //       // Filter out clusters with no batches
  //       const filteredClusters = updatedClusters.filter(
  //         (cluster) => cluster?.batches?.length > 0
  //       );

  //       // Sort clusters by createdAt in descending order (newest first)
  //       const sortedClusters = filteredClusters.sort((a, b) => {
  //         return new Date(b.createdAt) - new Date(a.createdAt);
  //       });

  //       setClusters(sortedClusters);
  //       if (onClusterChange) onClusterChange(sortedClusters.length);
  //       setClusterLoading(false);
  //     }
  //   } catch (error) {
  //     setClusterLoading(false);

  //     console.error("error in while fetching jobs", error);
  //   }
  // };
  const fetchAllCompletesCluster = async (id) => {
    setClusterLoading(true);
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_URL}/manufacturingJobs/completeClusters?campaignId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (data?.success && Array.isArray(data.data)) {
        setClusters(data.data);
        onClusterChange(data.data.length);
      } else {
        setClusters([]);
        onClusterChange(0);
      }
    } catch (error) {
      setClusters([]);
      onClusterChange(0);
      console.error("Error while fetching accepted clusters", error);
    } finally {
      setClusterLoading(false);
    }
  };

  const DataRow = ({ row }) => (
    <TableRow>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>{row?.storeName}</div>
        <div
          className={styles.address2}
        >{`${row?.address},${row?.city},${row?.state}-${row?.zipCode}`}</div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>{row?.storeOwnerName}</div>
        <div className={styles.storeManagerContact}>
          {row?.storeOwnerPhoneNumber}
        </div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {`${
            row?.product?.approvedWidth ?? row?.product?.productWidth ?? "N/A"
          } * 
         ${
           row?.product?.approvedHeight ?? row?.product?.productHeight ?? "N/A"
         } * 
         ${row?.product?.productThickness ?? "N/A"}`}
        </div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row?.product?.productType || "N/A"}
        </div>
      </TableCell>
      {/* <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row?.baseMaterial || "N/A"}
        </div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row?.printDetails || "N/A"}
        </div>
      </TableCell>
      <TableCell className={styles.tableCell}>
        {row?.product?.printImage ? (
          <div className={styles.iconLinkContainer}>
            <a
              href={row.product.printImage}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconLink}
            >
              <div className={styles.pdfIconWithText}>
                <img
                  src="/assests/AdminDashboard/pdfImage.png"
                  alt="Print File"
                  className={styles.pdfIcon}
                />
              </div>
            </a>
          </div>
        ) : (
          <div className={styles.sharedTextStyle}>No print file</div>
        )}
      </TableCell>
      <TableCell className={styles.tableCell}>
        {row?.materialDetailsForFabrication?.cadFile ? (
          <div className={styles.iconLinkContainer}>
            <a
              href={row.materialDetailsForFabrication.cadFile}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconLink}
            >
              <div className={styles.pdfIconWithText}>
                <img
                  src="/assests/AdminDashboard/pdfImage.png"
                  alt="CAD File"
                  className={styles.pdfIcon}
                />
              </div>
            </a>
          </div>
        ) : (
          <div className={styles.sharedTextStyle}>No CAD file</div>
        )}
      </TableCell>
      <TableCell className={styles.tableCell}>
        <div className={styles.sharedTextStyle}>
          {row.oemPreference || "N/A"}
        </div>
      </TableCell> */}
    </TableRow>
  );

  const searchData = useMemo(() => {
    const result = [];

    clusters.forEach((cluster) => {
      cluster.batches?.forEach((batch) => {
        batch.jobs?.forEach((job) => {
          result.push({
            id: job._id,
            storeName: job.storeName,
            clusterTitle: cluster.clusterTitle,
            batchTitle: batch.batchTitle,
            targetId: batch._id,
            subText: `${cluster.clusterTitle} → ${batch.batchTitle}`,
          });
        });
      });
    });

    return result;
  }, [clusters]);

  return (
    <Grid ref={containerRef} className={`${styles.scrollableContainer}`}>
      <div
        className="mx-3 py-2 sticky top-0 z-20 bg-white"
        
      >
        <StoreSearch
          data={searchData}
          searchKey="storeName"
          placeholder="Search Store"
          containerRef={containerRef}
          targetRefs={batchRefs}
          onSelect={(item) => {
            setExpandedCluster(item.clusterTitle);

            setExpandedBatch(item.batchTitle);
          }}
        />
      </div>
      {clusterLoading ? (
        <div className={styles.noJobsStyle}>
          <CircularProgress />
        </div>
      ) : clusters.length === 0 ? (
        <div className={styles.noJobsStyle}>
          <Box className={styles.noJobsBox}>
            <p className={styles.noJobsText}>
              No clusters of batches available
            </p>
          </Box>
        </div>
      ) : (
        clusters.map((cluster, index) => (
          <Grid item xs={12} md={12} key={index} my={1} mx={2}>
            <Accordion expanded={expandedCluster === cluster?.clusterTitle}>
              <AccordionSummary
                expandIcon={
                  <IconButton
                    onClick={handleAccordionToggle(cluster?.clusterTitle)}
                  >
                    <ExpandMoreIcon />
                  </IconButton>
                }
                aria-controls={`panel-${index}-content`}
                id={`panel-${index}-header`}
                className={styles.accordionHeader}
              >
                <div className={styles.batchHeader}>
                  <div className={styles.clusterTitle}>
                    {cluster?.clusterTitle}
                  </div>
                  <div className={styles.chipContainer}>
                    <Chip
                      label={`Batches: ${cluster?.batches?.length || 0}`}
                      className={styles.chip}
                    />
                    <Chip
                      label={`Jobs: ${calculateTotalJobsInCluster(cluster)}`}
                      className={styles.chip}
                    />
                    <Chip
                      label={`Allotted Timeline: ${moment(
                        cluster?.jobStartingDate,
                      ).format("DD MMM YY")} - ${moment(
                        cluster?.jobCompletionDate,
                      ).format("DD MMM YY")}`}
                      className={styles.chip}
                    />
                    <Chip
                      label={
                        <div className={styles.linkWithImage}>
                          {cluster?.vendorId?.vendorBusinessName || "N/A"}
                        </div>
                      }
                      className={styles.chip}
                    />

                    <Chip
                      key={index}
                      label={
                        cluster?.vendorId
                          ? `${Decrypt(cluster?.vendorId?.ownerName)} - ${
                              Decrypt(
                                cluster?.vendorId?.ownerPrimaryContactNo,
                              ) || "N/A"
                            }`
                          : "No Contact Info"
                      }
                      className={styles.chip}
                    />

                    <Chip
                      label={`Amount Paid: ${cluster?.amountPaid || 0}`}
                      className={styles.amountPaid}
                    />

                    {/* <button className={styles.ellipsisButton}>⋮</button> */}
                  </div>
                </div>
              </AccordionSummary>
              <AccordionDetails className={styles.accordionDetails}>
                <Box className={`${styles.scrollableBox}`}>
                  {cluster?.batches?.map((batch, batchIndex) => {
                    const isPainting = isPaintingService(batch);

                    return (
                      <div
                        ref={(el) => {
                          batchRefs.current[batch._id] = el;
                        }}
                      >
                        <Accordion
                          expanded={expandedBatch === batch?.batchTitle}
                          key={batchIndex}
                          className={`${styles.accordionCustom}`}
                        >
                          <AccordionSummary
                            expandIcon={
                              <IconButton
                                onClick={handleAccordionToggle(
                                  null,
                                  batch?.batchTitle,
                                )}
                              >
                                <ExpandMoreIcon />
                              </IconButton>
                            }
                            aria-controls={`panel-${batchIndex}-content`}
                            id={`panel-${batchIndex}-header`}
                          >
                            <div className={styles.batchHeader}>
                              <h1 className={styles.batchTitle}>
                                {batch?.batchTitle}
                              </h1>
                              <div className={styles.chipContainer}>
                                <Chip
                                  label={`Jobs: ${batch.jobs?.length || 0}`}
                                  className={styles.chip}
                                />
                                {/* Only show PDI status chip if NOT painting service */}
                                {!isPainting && (
                                  <Chip
                                    label={getStatusLabel(batch.pdiStatus)}
                                    className={
                                      batch.pdiStatus === "Requested"
                                        ? styles.pdiRequested
                                        : batch.pdiStatus === "Approved"
                                          ? styles.pdiApproved
                                          : ""
                                    }
                                  />
                                )}
                              </div>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails className={styles.accordionDetails}>
                            <Box className={`${styles.scrollableBox}`}>
                              <TableContainer
                                component={Paper}
                                className={styles.tableContainer}
                              >
                                <Table>
                                  <TableHead>
                                    <TableRow className={styles.tableHeader}>
                                      <TableCell className={styles.tableCell}>
                                        DELIVERY ADDRESS
                                      </TableCell>
                                      <TableCell className={styles.tableCell}>
                                        STORE MANAGER
                                      </TableCell>
                                      <TableCell className={styles.tableCell}>
                                        DIMENSIONS (W×H×T)
                                      </TableCell>
                                      <TableCell className={styles.tableCell}>
                                        PRODUCT TYPE
                                      </TableCell>
                                      {/* <TableCell className={styles.tableCell}>
                                      BASE MATERIAL
                                    </TableCell>
                                    <TableCell className={styles.tableCell}>
                                      PRINT DETAILS
                                    </TableCell>
                                    <TableCell className={styles.tableCell}>
                                      PRINT IMAGE
                                    </TableCell>
                                    <TableCell className={styles.tableCell}>
                                      CAD FILE
                                    </TableCell>
                                    <TableCell className={styles.tableCell}>
                                      OEM PREFERENCE
                                    </TableCell> */}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {batch?.jobs?.map((row, rowIndex) => (
                                      <DataRow key={rowIndex} row={row} />
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Box>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    );
                  })}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Grid>
        ))
      )}
    </Grid>
  );
};

export default Completed;
